<template>
  <v-breadcrumbs v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: "Breadcrumbs",
};
</script>
